"use client";

import { useEffect, useRef } from "react";
import { PlayIcon } from "./PlayIcon";

export function PlayHelpDialog({ onClose }: { onClose: () => void }) {
  const dialog = useRef<HTMLDialogElement>(null);
  const title = useRef<HTMLHeadingElement>(null);
  useEffect(() => {
    const previous = document.activeElement as HTMLElement | null;
    const element = dialog.current;
    element?.showModal();
    title.current?.focus();
    return () => { element?.close(); previous?.focus(); };
  }, []);
  return <dialog ref={dialog} className="play-help-dialog" aria-labelledby="play-help-title" onCancel={(event) => { event.preventDefault(); onClose(); }}>
    <button className="result-close" aria-label="Close playing guide" onClick={onClose}><PlayIcon name="close" /></button>
    <span className="club-eyebrow">Make yourself at home</span>
    <h2 id="play-help-title" ref={title} tabIndex={-1}>Your table, explained.</h2>
    <div className="play-help-grid">
      <section><PlayIcon name="arrow" /><h3>Make a move</h3><p>Select a piece, then a highlighted square. In 2D, you can also drag pieces. Choose a new piece when a pawn promotes.</p></section>
      <section><PlayIcon name="flip" /><h3>Find your view</h3><p>Drag an empty area to orbit the 3D board. Scroll to zoom, or choose a camera view. Reset restores your view.</p></section>
      <section><PlayIcon name="book" /><h3>Look back</h3><p>Use the replay arrows or select a move in the move list. Choose <strong>Back to game</strong> to continue playing.</p><span><kbd>←</kbd> <kbd>→</kbd> Previous / next move</span></section>
      <section><PlayIcon name="spark" /><h3>Take your time</h3><p>Every game is untimed. Find hints and takebacks beside the board, or under Game controls on smaller screens. Using one keeps your rating unchanged.</p></section>
    </div>
    <p className="play-help-note">Prefer the keyboard? Switch to 2D, focus the board, then use arrow keys and Enter to select a piece and destination.</p>
    <button className="club-primary" onClick={onClose}>Got it <PlayIcon name="check" /></button>
  </dialog>;
}
